import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import axios from 'axios'

window.Pusher = Pusher

let reconnectTimer = null

function createEchoInstance() {
	const echo = new Echo({
		broadcaster: 'pusher',
		key: process.env.VUE_APP_PUSHER_APP_KEY || 'main-key',
		cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER || 'mt1',
		wsHost: process.env.VUE_APP_PUSHER_HOST || 'websocket.mgnetwork.xyz',
		wsPort: parseInt(process.env.VUE_APP_PUSHER_PORT, 10) || 80,
		wssPort: parseInt(process.env.VUE_APP_PUSHER_PORT, 10) || 443,
		forceTLS: (process.env.VUE_APP_PUSHER_SCHEME || 'https') === 'https',
		enabledTransports: ['ws', 'wss'],
		disableStats: true,
		activityTimeout: 30000,
		pongTimeout: 5000,
		authorizer: (channel) => ({
			authorize: (socketId, callback) => {
				const token = sessionStorage.getItem('token')
				const authHeaders = { Accept: 'application/json' }
				if (token) authHeaders.Authorization = token

				const baseUrl = (process.env.VUE_APP_API_BASE_URL || '').replace(/\/api\/v1\/?$/, '').replace(/^http:/, 'https:')
				const authUrl = process.env.VUE_APP_PUSHER_AUTH || `${baseUrl}/broadcasting/auth`

				axios
					.post(
						authUrl,
						{ socket_id: socketId, channel_name: channel.name },
						{ withCredentials: true, headers: authHeaders },
					)
					.then(response => callback(false, response.data))
					.catch(error => callback(true, error))
			},
		}),
	})

	echo.connector.pusher.connection.bind('state_change', ({ current }) => {
		if (current === 'disconnected' || current === 'failed' || current === 'unavailable') {
			if (reconnectTimer) clearTimeout(reconnectTimer)
			reconnectTimer = setTimeout(() => {
				echo.connector.pusher.connect()
			}, 1000)
		}
		if (current === 'connected') {
			if (reconnectTimer) {
				clearTimeout(reconnectTimer)
				reconnectTimer = null
			}
		}
	})

	return echo
}

const LaravelEchoPlugin = {
	install(VueInstance) {
		if (process.env.VUE_APP_ENV === 'local') {
			window.Echo = null
			VueInstance.prototype.$echo = null
			return
		}

		const echo = createEchoInstance()
		window.Echo = echo
		VueInstance.prototype.$echo = echo
	},
}

export default LaravelEchoPlugin
